import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "w-100 h-100 position-relative" };
const _hoisted_2 = {
    key: 0,
    class: "component-title fw-bold small mb-3"
};
const _hoisted_3 = {
    class: "configuration-options position-absolute d-flex flex-column flex-md-row rounded",
    style: { "z-index": "999", "background-color": "rgba(255,255,255,0.8)" }
};
const _hoisted_4 = {
    key: 0,
    class: "d-flex align-items-center justify-content-center mx-3"
};
const _hoisted_5 = { class: "form-check" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = {
    class: "form-check-label",
    for: "engravingPrintModeRequest"
};
const _hoisted_8 = { class: "p-2" };
const _hoisted_9 = {
    class: "btn btn-primary d-inline-flex align-items-center",
    for: "lid-grid"
};
const _hoisted_10 = {
    key: 0,
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-check-lg",
    viewBox: "0 0 16 16"
};
const _hoisted_11 = { class: "w-100 h-100 d-flex align-items-center justify-content-center pt-5 mt-5" };
const _hoisted_12 = ["id"];
const _hoisted_13 = ["id"];
import { Canvas, Circle } from 'fabric';
import ImageManager from '@/Configurator/Shared/ImageManager.vue';
import TextManager from '@/Configurator/Shared/TextManager.vue';
import { onMounted, ref } from 'vue';
import ColorManager from '@/Configurator/Shared/ColorManager.vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import { standardFunctions } from '@/Configurator/Composables/standardFunctions';
import { debounce } from 'lodash';
import { canvasExport } from '../Composables/canvasExport';
import { useI18n } from 'vue-i18n';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LidConfiguration',
    props: {
        configurationId: String,
        tenantId: String,
        lid: Object
    },
    emits: ['update', 'blockFurtherConfiguration'],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        let { mmToPx } = standardFunctions();
        let { exportCanvasAsPNG } = canvasExport();
        const props = __props;
        const emit = __emit;
        const configurationKey = ref(Math.random().toString(36).substring(7));
        const maxTextsAmount = ref(3); //Mögliche Texte Anzahl
        const maxImagesAmount = ref(4); //Mögliche Bilder Anzahl
        const scaleFactor = ref(1); //Scale Faktor?
        const exactPreviewWidth = ref(500); //Vorschau Breite: exakte Breite der Deckel-Vorschau
        const shouldBlockFurtherConfiguration = ref(true); //Blockiere weitere Konfiguration //TODO: check if needed and when to set? Component does not allow further configuration
        const furtherConfigurationBlocked = ref(false); //Weitere Konfiguration blockiert
        const printAreaGridActive = ref(false); //Druckbereich Raster aktiv
        const configurationComponentId = ref('000000'); //Konfigurationskomponenten ID
        const lidWidth = ref(0); //Deckelbreite in mm
        const lidDepth = ref(0); //Deckelhöhe in mm
        const lidDiameter = ref(0); //Deckeldurchmesser in mm
        const printWidth = ref(0); //Druckbereich Breite in mm
        const printHeight = ref(0); //Druckbereich Höhe in mm
        const lidConfigImageSrc = ref(''); //Deckelkonfiguration Bild
        const lidConfigColor = ref(null); //Deckelkonfiguration Farbe
        //Colors
        const textColors = ref([]); //Textfarben
        const imageColors = ref([]); //Bildfarben
        const requiresDigitalPrintMode = ref(false); //Benötigt Digitaldruckmodus
        const maxColors = ref(null);
        //Configuration components
        const lidCanvas = ref(new Canvas()); //Verschluss Druckbereich
        const lidPreview = ref(new Canvas()); //Verschluss Vorschau
        const allowedPrintModes = ref([]); //Erlaubte Druckmodi
        const engravingPrintModeRequest = ref(false); //Gravur Druckmodus Anfrage
        const enableEngravingPrintModeSelection = ref(false); //Gravur Druckmodus Auswahl aktivieren
        const configurationIsExtensible = ref(true); //Konfiguration ist erweiterbar
        const saveConfigurationDebounced = debounce(() => {
            saveConfiguration();
        }, 1000); //Save configuration debounce after 1 second
        onMounted(() => {
            if (window.innerWidth < 600) {
                exactPreviewWidth.value = 300;
            }
            else {
                exactPreviewWidth.value = 500;
            }
            loadConfiguration();
        });
        function loadConfiguration() {
            axios.post(route('configurator.lidConfiguration.load', props.configurationId), {
                lidId: props.lid ? props.lid.id : null,
            })
                .then(function (response) {
                configurationComponentId.value = response.data.id;
                lidWidth.value = response.data.lid.width;
                lidDepth.value = response.data.lid.depth;
                lidDiameter.value = response.data.lid.diameter;
                printWidth.value = response.data.lid.printWidth;
                printHeight.value = response.data.lid.printHeight;
                lidConfigImageSrc.value = response.data.lid.configImage;
                lidConfigColor.value = response.data.lid.configColor;
                allowedPrintModes.value = response.data.lid.allowedPrintModes;
                maxColors.value = response.data.lid.maxColors;
                configurationIsExtensible.value = response.data.isExtensible;
                calculateScaleFactor();
                if (lidCanvas.value) {
                    lidCanvas.value.clear();
                    lidCanvas.value.dispose();
                }
                lidCanvas.value = new Canvas('lid-container-' + configurationKey.value, {
                    width: mmToPx(printWidth.value) / scaleFactor.value,
                    height: mmToPx(printHeight.value) / scaleFactor.value
                });
                assembleImages();
                loadPrintConfigurationData(); //Load print configuration data if already saved
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function loadPrintConfigurationData() {
            if (configurationComponentId.value) {
                axios.post(route('configurator.printConfiguration.load', configurationComponentId.value), {
                    configurationType: 'lid'
                })
                    .then(function (response) {
                    if (response.data.configuration) {
                        new Canvas()
                            .loadFromJSON(response.data.configuration)
                            .then((canvas) => {
                            lidCanvas.value.clear();
                            // Neue Canvas-Größe (falls sie sich geändert hat)
                            const newWidth = lidCanvas.value.width;
                            const newHeight = lidCanvas.value.height;
                            // Originalgröße aus gespeicherten Daten
                            const originalWidth = canvas.width;
                            const originalHeight = canvas.height;
                            // Skalierungsfaktoren berechnen
                            const scaleX = newWidth / originalWidth;
                            const scaleY = newHeight / originalHeight;
                            document.fonts.ready.then(() => {
                                canvas.getObjects().forEach((obj) => {
                                    // Skalierung anpassen
                                    obj.scaleX = (obj.scaleX || 1) * scaleX;
                                    obj.scaleY = (obj.scaleY || 1) * scaleY;
                                    obj.left = (obj.left || 0) * scaleX;
                                    obj.top = (obj.top || 0) * scaleY;
                                    obj.setCoords();
                                    // Editing-Blockierung setzen
                                    if (response.data.editingBlockedImages.includes(obj.get('id')) || response.data.editingBlockedTexts.includes(obj.get('id'))) {
                                        obj.set('editingBlocked', true);
                                        obj.selectable = false;
                                    }
                                    else {
                                        obj.set('editingBlocked', false);
                                        if (!obj.get('isFullDesign')) {
                                            obj.selectable = true;
                                        }
                                        else {
                                            obj.selectable = false;
                                        }
                                    }
                                    lidCanvas.value.add(obj);
                                });
                                lidCanvas.value.renderAll();
                                configurationKey.value = Math.random().toString(36).substring(7);
                            });
                        });
                    }
                    if (response.data.printModeId) {
                        engravingPrintModeRequest.value = response.data.printModeId == 3;
                    }
                    lidCanvas.value.on('object:modified', () => {
                        saveConfigurationDebounced();
                    });
                })
                    .catch(function (error) {
                    console.log(error);
                });
            }
        }
        function assembleImages() {
            var previewWidth = mmToPx(lidWidth.value) / scaleFactor.value;
            var previewHeight = mmToPx(lidDepth.value) / scaleFactor.value;
            if (lidPreview.value) {
                lidPreview.value.clear();
                lidPreview.value.dispose();
            }
            lidPreview.value = new Canvas('lid-bg-container-' + configurationKey.value, {
                width: previewWidth,
                height: previewHeight
            });
            var lidConfigImg = new Circle({
                radius: previewWidth / 2,
                fill: lidConfigColor.value,
                opacity: 0.8,
                selectable: false
            });
            lidPreview.value.add(lidConfigImg);
            lidPreview.value.sendObjectToBack(lidConfigImg);
            lidPreview.value.renderAll();
        }
        function updateLidCanvas(objects, updateType) {
            let textObjects = lidCanvas.value.getObjects('textbox');
            let imageObjects = lidCanvas.value.getObjects('image');
            let svgObjects = lidCanvas.value.getObjects('group', 'path');
            lidCanvas.value.clear();
            objects.forEach((obj) => {
                lidCanvas.value.add(obj);
                if (updateType == 'image') {
                    lidCanvas.value.sendObjectToBack(obj);
                }
            });
            if (updateType == 'image') {
                textObjects.forEach((obj) => {
                    lidCanvas.value.add(obj);
                });
            }
            else {
                imageObjects.forEach((obj) => {
                    lidCanvas.value.add(obj);
                    lidCanvas.value.sendObjectToBack(obj);
                });
                svgObjects.forEach((obj) => {
                    lidCanvas.value.add(obj);
                    lidCanvas.value.sendObjectToBack(obj);
                });
            }
            lidCanvas.value.renderAll();
            saveConfigurationDebounced();
        }
        function updateTextColors(colors) {
            textColors.value = colors;
        }
        function updateImageColors(colors, reqDigitalPrintMode) {
            // console.log('updateImageColors');
            // console.log(colors);
            // console.log(reqDigitalPrintMode);
            imageColors.value = colors;
            requiresDigitalPrintMode.value = reqDigitalPrintMode;
        }
        async function saveConfiguration() {
            if (configurationComponentId.value) {
                let canvasSvgExport = lidCanvas.value.toSVG();
                let canvasImageExport = null;
                const jsonConfiguration = JSON.stringify(lidCanvas.value.toObject([
                    'left', 'top', 'width', 'height', 'scaleX', 'scaleY', 'angle', 'opacity',
                    'visible', 'shadow', 'stroke', 'strokeWidth', 'fill', 'text', 'fontSize',
                    'fontFamily', 'fontWeight', 'backgroundColor', 'path', 'src', 'borderColor', 'cornerColor', 'cornerSize', 'transparentCorners', 'borderDashArray', 'cornerStyle',
                    'id', 'url', 'colors', 'requiredPrintMode', 'belowMinDPI', 'individualTextFileUrl', 'designElement', 'isFullDesign', 'editingBlocked'
                ]));
                canvasImageExport = await exportCanvasAsPNG(lidCanvas.value, jsonConfiguration, scaleFactor.value);
                axios.put(route('configurator.printConfiguration.update', configurationComponentId.value), {
                    configurationType: 'lid',
                    configuration: jsonConfiguration,
                    image: canvasImageExport,
                    svg: !canvasSvgExport.includes('xlink:href') ? canvasSvgExport : null,
                })
                    .catch(function (error) {
                    console.log(error);
                });
                emit('update');
            }
            else {
                console.error('Cannot save bottle canvas. Configuration Component ID is null');
            }
        }
        function setConfigurationBlock(blocked, message = '') {
            furtherConfigurationBlocked.value = blocked;
            if (blocked) {
                Swal.fire({
                    title: t('Achtung!'),
                    html: message,
                    icon: 'error',
                    confirmButtonText: t("Weitermachen"),
                    confirmButtonColor: "#528399",
                    footer: '<a href="#" data-bs-toggle="modal" data-bs-target="#printModes">' + t('Weitere Informationen zu unseren Druckverfahren') + '</a>'
                });
            }
            emit('blockFurtherConfiguration', blocked);
        }
        function calculateScaleFactor() {
            scaleFactor.value = mmToPx(lidWidth.value) / exactPreviewWidth.value;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (props.lid)
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_2, _toDisplayString(props.lid.name), 1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                        (lidCanvas.value && configurationIsExtensible.value && allowedPrintModes.value.length > 0)
                            ? (_openBlock(), _createBlock(ImageManager, {
                                configurationComponentId: configurationComponentId.value,
                                key: configurationKey.value,
                                maxImagesAmount: maxImagesAmount.value,
                                initialCanvas: lidCanvas.value,
                                allowedPrintModes: allowedPrintModes.value,
                                onUpdate: updateLidCanvas,
                                onUsedColors: updateImageColors
                            }, null, 8, ["configurationComponentId", "maxImagesAmount", "initialCanvas", "allowedPrintModes"]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", null, [
                        (lidCanvas.value && configurationIsExtensible.value)
                            ? (_openBlock(), _createBlock(TextManager, {
                                maxTextsAmount: maxTextsAmount.value,
                                initialCanvas: lidCanvas.value,
                                configurationComponentId: configurationComponentId.value,
                                key: configurationKey.value,
                                onUpdate: updateLidCanvas,
                                onUsedColors: updateTextColors
                            }, null, 8, ["maxTextsAmount", "initialCanvas", "configurationComponentId"]))
                            : _createCommentVNode("", true)
                    ]),
                    (allowedPrintModes.value.includes(3))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    value: "1",
                                    id: "engravingPrintModeRequest",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((engravingPrintModeRequest).value = $event)),
                                    disabled: !enableEngravingPrintModeSelection.value
                                }, null, 8, _hoisted_6), [
                                    [_vModelCheckbox, engravingPrintModeRequest.value]
                                ]),
                                _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)('Gravur-Druck gewünscht')), 1)
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            class: "btn-check",
                            id: "lid-grid",
                            autocomplete: "off",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((printAreaGridActive).value = $event))
                        }, null, 512), [
                            [_vModelCheckbox, printAreaGridActive.value]
                        ]),
                        _createElementVNode("label", _hoisted_9, [
                            (printAreaGridActive.value)
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[3] || (_cache[3] = [
                                        _createElementVNode("path", { d: "M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" }, null, -1)
                                    ]))]))
                                : _createCommentVNode("", true),
                            _createElementVNode("span", {
                                class: _normalizeClass({ 'ms-2': printAreaGridActive.value })
                            }, "Raster", 2)
                        ])
                    ])
                ]),
                (allowedPrintModes.value.length > 0)
                    ? (_openBlock(), _createBlock(ColorManager, {
                        key: 1,
                        maxColors: maxColors.value,
                        textColors: textColors.value,
                        imageColors: imageColors.value,
                        imagesAmount: lidCanvas.value.getObjects('image').length,
                        requiresDigitalPrintMode: requiresDigitalPrintMode.value,
                        shouldBlockFurtherConfiguration: shouldBlockFurtherConfiguration.value,
                        allowedPrintModes: allowedPrintModes.value,
                        configurationType: 'lid',
                        printConfigurationUuid: configurationComponentId.value,
                        preSelectedPrintType: engravingPrintModeRequest.value ? 3 : null,
                        onBlockFurtherConfiguration: setConfigurationBlock,
                        onCanSelectEngravingPrintMode: _cache[2] || (_cache[2] = ($event) => { enableEngravingPrintModeSelection.value = $event; if (!$event) {
                            engravingPrintModeRequest.value = false;
                        } })
                    }, null, 8, ["maxColors", "textColors", "imageColors", "imagesAmount", "requiresDigitalPrintMode", "shouldBlockFurtherConfiguration", "allowedPrintModes", "printConfigurationUuid", "preSelectedPrintType"]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", {
                        class: "d-flex justify-content-center align-items-center",
                        style: _normalizeStyle([{ "background-size": "cover" }, { width: _unref(mmToPx)(lidWidth.value) / scaleFactor.value + 'px', height: _unref(mmToPx)(lidDepth.value) / scaleFactor.value + 'px', backgroundImage: 'url(' + lidConfigImageSrc.value + ')' }])
                    }, [
                        _createElementVNode("canvas", {
                            id: 'lid-bg-container-' + configurationKey.value
                        }, null, 8, _hoisted_12),
                        _createElementVNode("canvas", {
                            id: 'lid-container-' + configurationKey.value,
                            class: _normalizeClass(["border rounded-circle border-3", { 'printAreaGrid': printAreaGridActive.value }]),
                            style: { "border-style": "dotted !important" }
                        }, null, 10, _hoisted_13)
                    ], 4)
                ])
            ]));
        };
    }
});
